<div class="login-auth-dialog">
  <form [formGroup]="setPasswordForm" class="login-auth-form" autocomplete="off">
    <div class="login-field">
      <label for="newPassword" translate>label_new_password</label>
      <div class="login-input-icon">
        <img class="input-prefix-icon" src="/assets/images/temp/login-lock.svg" alt="" aria-hidden="true" />
        <input type="password" id="newPassword" formControlName="newPassword" pInputText
          class="has-prefix-icon" [readonly]="isSubmitting" />
      </div>
      <div class="form-errors"
        *ngIf="setPasswordForm.controls.newPassword.errors && (setPasswordForm.controls.newPassword.dirty || setPasswordForm.controls.newPassword.touched)">
        <div *ngIf="setPasswordForm.controls.newPassword.errors.required" translate>error_new_password_required</div>
        <div *ngIf="setPasswordForm.controls.newPassword.errors.minlength || setPasswordForm.controls.newPassword.errors.pattern"
          translate>error_password_validation</div>
      </div>
    </div>

    <div class="login-field">
      <label for="newConfirmPassword" translate>label_new_confirm_password</label>
      <div class="login-input-icon">
        <img class="input-prefix-icon" src="/assets/images/temp/login-lock.svg" alt="" aria-hidden="true" />
        <input type="password" id="newConfirmPassword" formControlName="newConfirmPassword" pInputText
          class="has-prefix-icon" [readonly]="isSubmitting" />
      </div>
      <div class="form-errors"
        *ngIf="setPasswordForm.controls.newConfirmPassword.errors && (setPasswordForm.controls.newConfirmPassword.dirty || setPasswordForm.controls.newConfirmPassword.touched)">
        <div *ngIf="setPasswordForm.controls.newConfirmPassword.errors.required" translate>error_new_confirm_password_required</div>
        <div *ngIf="setPasswordForm.controls.newConfirmPassword.errors.minlength || setPasswordForm.controls.newConfirmPassword.errors.pattern"
          translate>error_password_validation</div>
      </div>
    </div>

    <div class="login-auth-actions">
      <button pButton appRipple type="button" class="login-auth-primary"
        [label]="'label_save' | translate"
        [disabled]="!setPasswordForm.valid || isSubmitting"
        (click)="doChangePassword()"></button>
      <button pButton appRipple type="button" class="login-auth-secondary p-button-outlined"
        [label]="'label_cancel' | translate"
        [disabled]="isSubmitting"
        (click)="onCancel()"></button>
    </div>
  </form>
</div>
